import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { VirtulOptionsComponent } from './virtul-options.component';
import { AccordionModule } from '@usitsdasdesign/dds-ng/accordion';
import { DataTableModule } from '../components/data-table/data-table.module';
import { HighlightModule } from '../common/highlight/highlight.module';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxModule } from '../components/checkbox/checkbox.module';
import { RadioModule } from '../components/radio/radio.module';
import { ButtonModule} from '../components/button/button.module'
@NgModule({
  declarations: [VirtulOptionsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AccordionModule,
    CheckboxModule,
    RadioModule,
    DataTableModule,
    HighlightModule,
    TranslateModule,
    ButtonModule
  ],
  exports:[VirtulOptionsComponent]
})
export class VirtualOptionModule { }
